var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.0304 22.6818L72.3225 4.02231C70.9366 2.64265 69.2409 1.61276 67.3761 1.018C65.5114 0.423231 63.5311 0.280713 61.5995 0.602248L33.4104 5.32351L33.3524 5.33408C18.8369 7.97941 8.14133 12.4323 3.12363 25.5658C-1.54827 37.7912 -0.979588 57.0624 5.02351 90.0028L5.75716 94.0285L14.9731 92.349L14.5429 123.623L22.7638 122.125L23.194 90.8508L25.925 90.3531C32.5234 89.2113 38.409 85.5249 42.3105 80.0901C45.8459 75.2224 47.9143 69.0676 48.2924 62.2911L48.2959 62.2301L49.1844 27.8824L40.9433 29.3843L40.1023 61.8999C39.6061 70.486 35.2389 80.3369 24.4577 82.3017L12.3721 84.5042C7.39758 55.9657 6.91829 38.5957 10.7845 28.4765C14.0291 19.9823 20.3145 16.0316 34.7915 13.3894L62.9506 8.67356C63.5945 8.56639 64.2546 8.61389 64.8762 8.81215C65.4978 9.0104 66.063 9.3537 66.525 9.81359L87.6867 30.9185L110.882 30.5608L111.659 34.8278L111.547 55.4949C111.513 61.5947 110.161 64.9109 102.563 67.2576L71.7128 78.4974L77.6241 112.127L85.6912 110.657L80.9763 83.8319L105.083 75.0452C110.594 73.3262 114.423 70.7552 116.786 67.1873C118.806 64.1369 119.719 60.5436 119.746 55.5338L119.863 34.1059L117.706 22.27L91.0304 22.6818Z",
    fill: "#DAF0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.32632f8328cb8227df3aa1115d8da32a.svg";
export { ForwardRef as ReactComponent };